import { render, staticRenderFns } from "./BulkExpiryDateUpdate.vue?vue&type=template&id=7f1da65a&"
import script from "./BulkExpiryDateUpdate.vue?vue&type=script&lang=js&"
export * from "./BulkExpiryDateUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports